let isAdminIdentified = false;

const formatAdminId = (adminId) => {
  const idString = String(adminId);
  return idString.padStart(5, '0');
};

export const initAmplitude = ({ accountId, accountIds, status, adminId, isUbeyaAdmin }) => {
  if (!adminId || process.env.ENV === 'LOCAL') {
    return;
  }

  // Check if Amplitude was initialized
  if (!window.amplitudeInitialized || !window.amplitude) {
    // eslint-disable-next-line
    console.error('Amplitude was not initialized in HTML. Session replay will not be available.');
    return;
  }

  const adminIdString = formatAdminId(adminId);

  // Only set admin ID if not already set
  if (!isAdminIdentified) {
    window.amplitude.setUserId(adminIdString);
    isAdminIdentified = true;
  }

  // Always update admin properties
  // Note: We need to use the global Identify constructor
  const identify = new window.amplitude.Identify()
    .set('accountId', accountId)
    .set('accountIds', accountIds)
    .set('billingStatus', status)
    .set('isUbeyaAdmin', isUbeyaAdmin);

  window.amplitude.identify(identify);
};

export const trackEvent = (eventName, eventProperties = {}) => {
  if (!eventName || typeof eventName !== 'string') {
    return;
  }
  if (process.env.ENV === 'LOCAL') {
    // eslint-disable-next-line
    console.log(`Amplitude event: ${eventName}`);
    return;
  }

  // Check if amplitude is available
  if (!window.amplitude || !window.amplitude.track) {
    // eslint-disable-next-line
    console.error('Amplitude is not available. Cannot track event:', eventName);
    return;
  }

  const cleanProperties = Object.fromEntries(
    Object.entries(eventProperties).filter(([, value]) => value !== null && value !== undefined)
  );

  window.amplitude.track(eventName, cleanProperties);
};
